import { InjectionToken } from '@angular/core';
import { ActivityReportsPort } from './app-activity-reports.port';

export const APP_REPORTS_PORT = new InjectionToken<ActivityReportsPort>('APP_REPORTS_PORT');